import { render, staticRenderFns } from "./WsParticipantsPersonalData.vue?vue&type=template&id=20323e94&scoped=true"
import script from "./WsParticipantsPersonalData.vue?vue&type=script&lang=js"
export * from "./WsParticipantsPersonalData.vue?vue&type=script&lang=js"
import style0 from "./WsParticipantsPersonalData.vue?vue&type=style&index=0&id=20323e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20323e94",
  null
  
)

export default component.exports